"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneField = void 0;

var tslib_1 = require("tslib");

var ui_field_error_message_1 = require("@hopin-team/ui-field-error-message");

var ui_field_helper_message_1 = require("@hopin-team/ui-field-helper-message");

var ui_field_label_1 = require("@hopin-team/ui-field-label");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_menu_1 = require("@hopin-team/ui-menu");

var use_id_1 = require("@hopin-team/use-id");

var google_libphonenumber_1 = require("google-libphonenumber");

var react_1 = tslib_1.__importStar(require("react"));

var react_virtuoso_1 = require("react-virtuoso");

var get_localized_region_display_name_1 = require("./helpers/get-localized-region-display-name");

var polyfill_intl_display_names_1 = require("./helpers/polyfill-intl-display-names");

var region_menu_select_item_1 = require("./partials/region-menu-select-item");

var common_region_menu_section_1 = require("./styled/common-region-menu-section");

var flag_1 = require("./styled/flag");

var input_1 = require("./styled/input");

var region_button_1 = require("./styled/region-button");

var region_menu_content_1 = require("./styled/region-menu-content");

var phoneUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
var regionCodes = phoneUtil.getSupportedRegions();

var PhoneField = function PhoneField(_a) {
  var __UIScope = _a.__UIScope,
      className = _a.className,
      errorMessage = _a.errorMessage,
      hasErrors = _a.hasErrors,
      helperText = _a.helperText,
      id = _a.id,
      _b = _a.initialPhoneValue,
      initialPhoneValue = _b === void 0 ? '' : _b,
      _c = _a.initialRegionCodeValue,
      initialRegionCodeValue = _c === void 0 ? 'US' : _c,
      isRequired = _a.isRequired,
      label = _a.label,
      _d = _a.locale,
      locale = _d === void 0 ? 'en' : _d,
      name = _a.name,
      onChange = _a.onChange,
      requiredText = _a.requiredText,
      _e = _a.sizeOption,
      sizeOption = _e === void 0 ? 'medium' : _e,
      _f = _a.commonRegionCodes,
      commonRegionCodes = _f === void 0 ? ['GB', 'CA', 'US'] : _f,
      _g = _a.buttonLabel,
      buttonLabel = _g === void 0 ? 'country codes' : _g;

  var _h = tslib_1.__read((0, react_1.useState)(initialPhoneValue), 2),
      phoneValue = _h[0],
      setPhoneValue = _h[1];

  var _j = tslib_1.__read((0, react_1.useState)(initialRegionCodeValue), 2),
      regionCodeValue = _j[0],
      setRegionCodeValue = _j[1];

  var isFirstRender = (0, react_1.useRef)(true);

  var _id = (0, use_id_1.useId)(id);

  var fieldId = "field-".concat(_id);
  var menuId = "menu-".concat(_id);
  var errorMsgId = "error-msg-".concat(_id);
  var helperMsgId = "helper-msg-".concat(_id);
  var a11yProps = {};

  if (hasErrors && errorMessage) {
    a11yProps['aria-describedby'] = errorMsgId;
  }

  if (!hasErrors && helperText) {
    a11yProps['aria-describedby'] = helperMsgId;
  }

  var _k = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'PhoneField',
    className: className,
    __UIScope: __UIScope
  }),
      makeClasses = _k.makeClasses,
      rootClasses = _k.rootClasses;

  var _l = tslib_1.__read((0, react_1.useState)(false), 2),
      menuIsShowing = _l[0],
      setMenuIsShowing = _l[1];

  var onOpenMenuButtonClick = function onOpenMenuButtonClick() {
    return setMenuIsShowing(!menuIsShowing);
  };

  var handleCountryClick = (0, react_1.useCallback)(function (regionCode) {
    setRegionCodeValue(regionCode);
    setMenuIsShowing(false);
  }, [setRegionCodeValue]);
  var createItemPropsFromRegionCodes = (0, react_1.useCallback)(function (regionCodes) {
    return regionCodes.map(function (regionCode) {
      var _a;

      return {
        countryCode: phoneUtil.getCountryCodeForRegion(regionCode),
        name: Intl.DisplayNames ? (_a = (0, get_localized_region_display_name_1.getLocalizedRegionDisplayName)(regionCode, locale)) !== null && _a !== void 0 ? _a : regionCode.toUpperCase() : regionCode.toUpperCase(),
        onClick: function onClick() {
          return handleCountryClick(regionCode);
        },
        regionCode: regionCode
      };
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }, [handleCountryClick, locale]);
  var commonCountryOptions = createItemPropsFromRegionCodes(commonRegionCodes);
  var allCountryOptions = createItemPropsFromRegionCodes(regionCodes);
  var exampleNationalNumber = (0, react_1.useMemo)(function () {
    var _a;

    return (_a = phoneUtil.getExampleNumber(regionCodeValue).getNationalNumber()) === null || _a === void 0 ? void 0 : _a.toString();
  }, [regionCodeValue]);
  (0, react_1.useEffect)(function () {
    (0, polyfill_intl_display_names_1.polyfillIntlDisplayNames)(locale);
  }, [locale]);
  (0, react_1.useEffect)(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      var isValidNumber = void 0;

      try {
        isValidNumber = phoneUtil.isValidNumber(phoneUtil.parse(phoneValue, regionCodeValue));
      } catch (_a) {
        isValidNumber = false;
      }

      if (onChange) {
        onChange({
          phone: phoneValue,
          regionCode: regionCodeValue,
          isValidNumber: isValidNumber
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [phoneValue, regionCodeValue]);

  var handleNumInputChange = function handleNumInputChange(e) {
    setPhoneValue(e.currentTarget.value);
  };

  var listData = commonCountryOptions.length > 0 ? commonCountryOptions.concat(allCountryOptions) : allCountryOptions;
  return react_1.default.createElement("div", {
    className: rootClasses
  }, react_1.default.createElement(ui_field_label_1.FieldLabel, {
    className: makeClasses('Label'),
    fieldId: fieldId,
    label: label,
    isRequired: isRequired,
    requiredText: requiredText,
    mb: 0.5
  }), react_1.default.createElement(ui_flex_1.Flex, null, react_1.default.createElement(region_button_1.RegionButton, {
    "aria-haspopup": "true",
    type: "button",
    "aria-label": buttonLabel,
    "aria-expanded": menuIsShowing,
    className: makeClasses('Button'),
    "data-testid": "phone-field-region-button",
    id: "country-codes",
    onClick: onOpenMenuButtonClick,
    size: sizeOption
  }, react_1.default.createElement(flag_1.Flag, {
    regionCode: regionCodeValue
  })), react_1.default.createElement(input_1.Input, tslib_1.__assign({
    "aria-invalid": hasErrors,
    className: makeClasses('Input'),
    type: "tel",
    autoComplete: "tel",
    id: fieldId,
    hasErrors: hasErrors,
    name: name,
    onChange: handleNumInputChange,
    required: isRequired,
    value: phoneValue,
    placeholder: exampleNationalNumber,
    sizeOption: sizeOption
  }, a11yProps))), react_1.default.createElement(ui_menu_1.Menu, {
    id: menuId,
    isShowing: menuIsShowing,
    "data-testid": "phone-field-menu"
  }, react_1.default.createElement(region_menu_content_1.RegionMenuContent, {
    p: 1
  }, react_1.default.createElement(ui_menu_1.MenuSelect, {
    labelledById: "country-codes"
  }, react_1.default.createElement(react_virtuoso_1.Virtuoso, {
    initialItemCount: 10,
    totalCount: listData.length,
    style: {
      height: '11rem'
    },
    data: listData,
    itemContent: function itemContent(index, item) {
      return Array.isArray(item) ? react_1.default.createElement(common_region_menu_section_1.CommonRegionMenuSection, null, item.map(function (subItem, ix) {
        return react_1.default.createElement(region_menu_select_item_1.RegionMenuSelectItem, tslib_1.__assign({
          key: ix
        }, subItem));
      })) : react_1.default.createElement(region_menu_select_item_1.RegionMenuSelectItem, tslib_1.__assign({
        key: index
      }, item));
    }
  })))), hasErrors && errorMessage && react_1.default.createElement(ui_field_error_message_1.FieldErrorMessage, {
    className: makeClasses('ErrorMessage'),
    mt: 1,
    errorMessage: errorMessage,
    id: errorMsgId
  }), !hasErrors && helperText && react_1.default.createElement(ui_field_helper_message_1.FieldHelperMessage, {
    helperMessage: helperText,
    mt: 1,
    className: makeClasses('HelperMessage'),
    id: helperMsgId
  }));
};

var PhoneFieldWithSpace = (0, ui_helper_with_space_1.withSpace)(PhoneField);
exports.PhoneField = PhoneFieldWithSpace;